const SET_SUBMISSION_REPORT_DATE_RANGE = (state, { field, value }) => {
  state.currentAdministrator.submissionsReport[field] = value;
  state.submissionsReportErrors = [];
};

export default SET_SUBMISSION_REPORT_DATE_RANGE;
